export class SetPathAction {
  public static readonly type = '[Project/Storage/List] SetPathAction';
  constructor(public readonly path: string | null) {}
}
